import { render } from "./EdoDocumentsItem.vue?vue&type=template&id=0415180f"
import script from "./EdoDocumentsItem.vue?vue&type=script&lang=js"
export * from "./EdoDocumentsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__